import React, { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import './NewVersionMessage.scss';

interface NewVersionMessageProps {
    handleReloadClick?: () => void;
}

export const NewVersionMessage: FC<NewVersionMessageProps> = ({ handleReloadClick }) => {
    const { t } = useTranslation('navigation', { useSuspense: false });

    return (
        <div className="new_version_available_message_container" role="alert" aria-live="polite">
            {t('new_version_available_message', 'New version of Provider Hub is available!')}
            <button className="inline_button reload_page_button" onClick={handleReloadClick || (() => window.location.reload())}>
                {t('reload_button_label', 'Click here to reload!')}
            </button>
        </div>
    )
}
